export const BatchTooltipText = {
  excludedFromUpload:
    'Claims that could not be validated during the upload process (see the Excluded Claims Validation report for details).',
  importedOnly: 'Claims that were uploaded for Import Only or were not eligible for AutoCheck.',
  noStatus: 'Claims whose AutoCheck calls were interrupted and did not complete processing.',
  stoppedRepeatCalls:
    'An AutoCheck call had already been made for these claims, and the option to repeat calls was not selected.',
  awaitingEOB: 'This batch has been uploaded for AutoCheck processing to request Enhanced Claim Status and EOBs.',
  autoCheck: 'This batch has been uploaded for AutoCheck processing to request Enhanced Claim Status.',
  importOnly: 'This batch has been uploaded for Import Only, bypassing the AutoCheck process.',
  claimAutoChecked:
    'The total time starts from when the batch is initiated to the end of the last call. This includes any pauses needed to accommodate payer business hours.',
  eobReceived:
    'This is the amount of time remaining to receive EOBs in the 24 hour window from the time the AutoCheck completes.',
  repeatCallsOn: 'Repeat calls for previously checked claims have been enabled.',
  repeatCallOff: 'Repeat calls for previously checked claims have been disabled.',
  stoppedRepeatCallsOff:
    'If the Repeat Calls option was not selected, subsequent calls were not placed on qualifying claims.',
  nextActionCalls: 'Calls placed automatically for retries or alternate payer outreach or escalation',
  claimASC: 'This batch has been uploaded for AutoCheck processing to request Appeal Status Check.',
}
